// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import maskInput from '../../../utils/maskInput';

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');
    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.renderAdditionalForm();
  }

  @on({ event: 'change', selector: '#company_growth_stage' })
  onChangeGrowthStage() {
    this.renderAdditionalForm();
  }

  renderAdditionalForm() {
    const growthStage = $('#company_growth_stage').val();
    $('.display-growth-stage-note').css(
      'display',
      growthStage === 'other' ? 'block' : 'none',
    );
    maskInput();
  }
}
